<script>
import validationRules from '../../../mixins/validationRules';

export default {
  name: 'Date',
  mixins: [
    validationRules,
  ],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      modifiableData: undefined,
    };
  },
  created() {
    if (this.data && this.data.date) {
      this.modifiableData = {
        date: this.data.date,
      };
    } else {
      this.modifiableData = {
        date: undefined,
      };
    }
    this.$emit('update:data', this.modifiableData);
  },
};
</script>

<template>
  <v-layout row>
    <v-flex xs12>
      <v-text-field
        v-model="modifiableData.date"
        :rules="[validationRules.required, validationRules.date('DD-MM-YY')]"
        class="text-field-height-fix"
        label="Date (DD-MM-YY)"
        mask="##-##-##"
        return-masked-value
        clearable
        box
        @input="$emit('update:data', modifiableData)"
      />
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/Reminders/ReminderRuleSettingTypes/Date.vue